export const models = [
  {
    id: 'acanthopyge',
    name: 'Acanthopyge',
    italic: true,
    description: [
      ['Group', 'Lichida'],
      ['Age', 'Devonian'],
      ['Country', 'Morocco'],
      ['Size', '5.2cm'],
      [
        'Display',
        '<a href="https://ssl.eas.ualberta.ca/museum-display/diversity_detail.php?id=76">Dynamic Diversity #76</a>'
      ],
      [
        'Description',
        'This trilobite has lengthy spines and is missing its free cheeks.'
      ]
    ],
    model: '/assets/viewer/acanthopyge.glb',
    image: '/assets/img/trilobites/acanthopyge.jpg',
    position: [0, 110, 0],
    rotation: [0, 0, 0],
    zoomBounds: [0.03, 0.1]
  },
  {
    id: 'bohemolichas',
    name: 'Bohemolichas incola',
    italic: true,
    description: [
      ['Group', 'Lichida'],
      ['Age', 'Devonian'],
      ['Country', 'Czech Republic'],
      ['Size', '12.5cm'],
      ['Display', 'Not on display'],
      [
        'Description',
        'Every part of this trilobite is covered in small bumps.'
      ]
    ],
    model: '/assets/viewer/bohemolichas.glb',
    image: '/assets/img/trilobites/bohemolichas.jpg',
    position: [0, 60, 0],
    rotation: [0, 0, 0],
    zoomBounds: [0.03, 0.1]
  },
  {
    id: 'dicranurus',
    name: 'Dicranurus monstrosus',
    italic: true,
    description: [
      ['Group', 'Odontopleurida'],
      ['Age', 'Devonian'],
      ['Country', 'Morocco'],
      ['Size', '5.5.cm'],
      [
        'Display',
        '<a href="https://ssl.eas.ualberta.ca/museum-display/diversity_detail.php?id=79">Dynamic Diversity #79</a>'
      ],
      [
        'Description',
        'Few trilobite species have such curved spines.'
      ]
    ],
    model: '/assets/viewer/dicranurus.glb',
    image:
      '/assets/img/trilobites/dicranurus-monstrosus.jpg',
    position: [0, 110, 0],
    rotation: [0, 0, 0],
    zoomBounds: [0.03, 0.1]
  },
  {
    id: 'drotops-armatus',
    name: 'Drotops armatus',
    italic: true,
    description: [
      ['Group', 'Phacopida'],
      ['Age', 'Devonian'],
      ['Country', 'Morocco'],
      ['Size', '14.4cm'],
      ['Display', 'Not on display'],
      [
        'Description',
        'This trilobite has spines covering its body and above its eyes.'
      ]
    ],
    model: '/assets/viewer/drotops-armatus.glb',
    image: '/assets/img/trilobites/drotops-armatus.jpg',
    position: [0, 100, 0],
    rotation: [0, 0, 0],
    zoomBounds: [0.03, 0.1]
  },
  {
    id: 'drotops-megalomanicus',
    name: 'Drotops megalomanicus',
    italic: true,
    description: [
      ['Group', 'Phacopida'],
      ['Age', 'Devonian'],
      ['Country', 'Morocco'],
      ['Size', '13.7cm'],
      ['Display', 'Discover Technology Display Drawer'],
      [
        'Description',
        'This trilobite has simple ornamentation and lacks spines.'
      ]
    ],
    model:
      '/assets/puzzles/drotops-megalomanicus/solved.glb',
    image:
      '/assets/img/trilobites/drotops-megalomanicus.jpg',
    position: [0, 70, 0],
    rotation: [0, 0, 0],
    zoomBounds: [0.03, 0.1]
  },
  {
    id: 'erbenochile',
    name: 'Erbenochile',
    italic: true,
    description: [
      ['Group', 'Phacopida'],
      ['Age', 'Devonian'],
      ['Country', 'Morocco'],
      ['Size', '8.3cm'],
      ['Display', 'Not on display'],
      [
        'Description',
        'Long spines extend from the ends of the cephalon.'
      ]
    ],
    model: '/assets/viewer/erbenochile.glb',
    image: '/assets/img/trilobites/erbenochile.jpg',
    position: [0, 130, 0],
    rotation: [0, 0, 0],
    zoomBounds: [0.03, 0.09]
  },
  {
    id: 'harpes',
    name: 'Harpes',
    italic: true,
    description: [
      ['Group', 'Harpetida'],
      ['Age', 'Devonian'],
      ['Country', 'Morocco'],
      ['Size', '3.9cm'],
      [
        'Display',
        '<a href="https://ssl.eas.ualberta.ca/museum-display/diversity_detail.php?id=35">Dynamic Diversity #35</a>'
      ],
      [
        'Description',
        'This species has a huge cephalon compared to the rest of its body.'
      ]
    ],
    model: '/assets/viewer/harpes.glb',
    image: '/assets/img/trilobites/harpes.jpg',
    position: [0, 120, 0],
    rotation: [0, 0, 0],
    zoomBounds: [0.03, 0.1]
  },
  {
    id: 'odontopleurid',
    name: 'Leonaspid',
    italic: false,
    description: [
      ['Group', 'Odontopleurida'],
      ['Age', 'Devonian'],
      ['Country', 'Morocco'],
      ['Size', '3.7cm'],
      ['Display', 'Not on display'],
      [
        'Description',
        'The serrations at the front of the cephalon are unique to this group.'
      ]
    ],
    details: '',
    model: '/assets/viewer/odontopleurid.glb',
    image: '/assets/img/trilobites/leonaspid.jpg',
    position: [0, 100, 0],
    rotation: [0, 0, 0],
    zoomBounds: [0.03, 0.1]
  },
  {
    id: 'mrakibina',
    name: 'Mrakibina cattoi',
    italic: true,
    description: [
      ['Group', 'Phacopida'],
      ['Age', 'Devonian'],
      ['Country', 'Morocco'],
      ['Size', '3.6cm'],
      [
        'Display',
        '<a href="https://ssl.eas.ualberta.ca/museum-display/diversity_detail.php?id=64">Dynamic Diversity #64</a>'
      ],
      [
        'Description',
        'This trilobite has a fan of spines at the end of the pygidium.'
      ]
    ],
    details: '',
    model: '/assets/viewer/mrakibina.glb',
    image: '/assets/img/trilobites/mrakibina-cattoi.jpg',
    position: [0, 110, 0],
    rotation: [0, 0, 0],
    zoomBounds: [0.03, 0.1]
  },
  {
    id: 'paralejurus',
    name: 'Paralejurus',
    italic: true,
    description: [
      ['Group', 'Corynexochida'],
      ['Age', 'Devonian'],
      ['Country', 'Morocco'],
      ['Size', '9.1cm'],
      ['Display', 'Not on display'],
      [
        'Description',
        'This trilobite is smooth compared to most other species. '
      ]
    ],
    details: '',
    model: '/assets/viewer/paralejurus.glb',
    image: '/assets/img/trilobites/paralejurus.jpg',
    position: [0, 120, 0],
    rotation: [0, 0, 0],
    zoomBounds: [0.03, 0.1]
  }
]
